import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"

export interface ChatSearch {
  conversation?: string
  isNew?: string
}

export const Route = createFileRoute("/chat")({
  validateSearch: (search: Record<string, unknown>): ChatSearch => ({
    conversation: typeof search.conversation === "string" ? search.conversation : undefined,
    isNew: typeof search.isNew === "string" ? search.isNew : undefined,
  }),
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) throw redirect({ to: "/login" })
  },
})